// © Microsoft Corporation. All rights reserved.
import React, { useEffect, useState } from 'react';
import { Separator, Pivot, PivotItem, Stack, CommandButton } from '@fluentui/react';
import { Call, LocalVideoStream, VideoDeviceInfo } from '@azure/communication-calling';
import { MediaControls } from './MediaControls';
import { CommandPanelTypes } from './CommandPanel';
import { UserFriendsIcon, SettingsIcon, ChatIcon, AddIcon } from '@fluentui/react-icons-northstar';
import { Constants } from 'core/constants';
import { useMediaQuery } from "@material-ui/core";
import {
  headerContainer,
  pivotItemStyles,
  separatorContainerStyle,
  separatorStyles,
  pivotItemStyle,
  headerCenteredContainer,
  feedbackContainer,
  recordingIcon,
  recordingSplitter
} from './styles/Header.styles';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ParticipantStream } from 'core/reducers';
import CallRecording from '../containers/CallRecording';
import { FeedbackButton } from './FeedbackButton';
import logo from "../Liberian-Registry-logo.png"
import { utils } from 'Utils/Utils';
import { CAT, getThreadId } from '../Utils/Utils';
import {
  localStorageAvailable,
  getDisplayFirstNameFromLocalStorage,
  getDisplayLastNameFromLocalStorage
} from '../Utils/localStorage';

export interface HeaderProps {
  selectedPane: CommandPanelTypes;
  setSelectedPane: any;
  setSelectedPaneDefault: any;
  endCallHandler(): void;
  actionable: boolean;
  localVideo: boolean;
  mic: boolean;
  shareScreen: boolean;
  call: Call;
  endCall(): void;
  screenShareStreams: ParticipantStream[];
  activeScreenShareStream: ParticipantStream | undefined;
  localVideoRendererIsBusy: boolean;
  cameraPermission: string;
  microphonePermission: string;
  screenWidth: number;
  groupId: string;
  setMic(mic: boolean): void;
  setLocalVideoStream(localVideoStream: LocalVideoStream | undefined): void;
  setScreenShare(screenShare: boolean): void;
  isLocalScreenShareSupportedInBrowser(): boolean;
  localVideoStream: LocalVideoStream | undefined;
  videoDeviceInfo: VideoDeviceInfo | undefined;
  recordingStatus: 'STARTED' | 'STOPPED';
  setup(displayName: string, emoji: string): any;
  isValidThread(threadId: string | null, groupId: string): any;
  darkColor: string;
  lightColor: string;
  employeesCount: number;
  connected: any;
}

export const Header = (props: HeaderProps): JSX.Element => {
  const [isFeedbackEnabled, setIsFeedbackEnabled] = useState(false);
  const [isRecordingEnabled, setIsRecordingEnabled] = useState(false);
  const compressedMode = props.screenWidth <= Constants.MINI_HEADER_WINDOW_WIDTH;
  const isRecordingOn = props.recordingStatus === 'STARTED';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { setup } = props;
  const isValidThreadProp = props.isValidThread;
  const username = localStorageAvailable ? (getDisplayFirstNameFromLocalStorage() + ' ' + getDisplayLastNameFromLocalStorage()) : '';

  // useEffect(() => {
  //   if (props.employeesCount > 0) {
  //     setIsRecordingEnabled(true);
  //   }
  // }, [props.employeesCount])

  useEffect(() => {
    setIsRecordingEnabled(true);
  }, [])

  useEffect(() => {
    (async () => {
      // const settings = await utils.getFeedbackSettings();
      // setIsFeedbackEnabled(settings.isFeedbackEnabled);

      // const recordingSettings = await utils.getRecordingSettings();
      // setIsRecordingEnabled(recordingSettings.isRecordingEnabled);
    })();
    if (window.innerWidth > Constants.MINI_HEADER_WINDOW_WIDTH) {
      toggleChat(props.selectedPane, props.setSelectedPane);
    }
  }, [])

  useEffect(() => {
    const isValidThread = async () => {
      if (await isValidThreadProp(getThreadId(), props.groupId)) {
        setup(username, CAT);
        // toggleChat(props.selectedPane, props.setSelectedPane);
      }
    };
    isValidThread();
    document.getElementById('🐱')?.focus();
  }, [isValidThreadProp]);


  const togglePeople = (selectedPane: string, setSelectedPane: (pane: string) => void) => {
    return selectedPane !== CommandPanelTypes.People
      ? setSelectedPane(CommandPanelTypes.People)
      : setSelectedPane(CommandPanelTypes.None);
  };

  const toggleAdd = (selectedPane: string, setSelectedPane: (pane: string) => void) => {
    return selectedPane !== CommandPanelTypes.Add
      ? setSelectedPane(CommandPanelTypes.Add)
      : setSelectedPane(CommandPanelTypes.None);
  };

  const toggleChat = (selectedPane: string, setSelectedPane: (pane: string) => void) => {
    return selectedPane !== CommandPanelTypes.Chat
      ? setSelectedPane(CommandPanelTypes.Chat)
      : setSelectedPane(CommandPanelTypes.None);
  };

  const toggleOptions = (selectedPane: string, setSelectedPane: (pane: string) => void) => {
    return selectedPane !== CommandPanelTypes.Settings
      ? setSelectedPane(CommandPanelTypes.Settings)
      : setSelectedPane(CommandPanelTypes.None);
  };

  const handleLocalVideoOnOff = async () => {
    if (props.localVideoStream) {
      await props.call.stopVideo(props.localVideoStream);
      props.setLocalVideoStream(undefined);
    } else {
      if (props.videoDeviceInfo) {
        const localVideoStream = new LocalVideoStream(props.videoDeviceInfo);
        props.setLocalVideoStream(localVideoStream);
        await props.call.startVideo(localVideoStream);
      }
    }
  };

  const handleMuteOnOff = () => {
    props.setMic(!props.mic);
  };

  const handleScreenSharingOnOff = () => {
    props.setScreenShare(!props.shareScreen);
  };

  useEffect(() => {
    if (props.call && props.call.localVideoStreams.length === 0 && props.localVideoStream) {
      props.call.startVideo(props.localVideoStream);
    }
  }, [props.call, props.localVideoStream]);

  return (
    <Stack
      id="header" style={{ position: 'fixed', zIndex: '9999' }}
      className={props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? headerContainer : headerCenteredContainer}
    >
      {!isMobile && <div className='App-header-logo'> <a href='https://www.liscr.com/' target={'_blank'}>  <img src={logo} alt="logo" /></a></div>}
      <Stack.Item grow={1} className={feedbackContainer}>
        {isFeedbackEnabled && <FeedbackButton iconOnly={compressedMode} />}
        {isFeedbackEnabled && isRecordingOn && <div className={recordingSplitter}>
          <Separator styles={separatorStyles} vertical={true} />
        </div>}
        {/* {((props.employeesCount > 0)) && */}
        <CommandButton
          className={recordingIcon + '  ' + 'mob_recording_icon'}
          key='RadioBtnOn'
          text={compressedMode ? undefined : 'Recording'}
          ariaLabel={compressedMode ? 'Recording' : undefined}
          iconProps={{ iconName: 'RadioBtnOn' }}
        />
        {/* } */}
      </Stack.Item>

      <Pivot
        onKeyDownCapture={(e) => {
          if ((e.target as HTMLElement).id === CommandPanelTypes.People && e.keyCode === 39) e.preventDefault();
        }}
        getTabId={(itemKey: string) => itemKey}
        onLinkClick={(item) => {
          if (!item) return;
          if (item.props.itemKey === CommandPanelTypes.Settings) toggleOptions(props.selectedPane, props.setSelectedPane); props.setSelectedPaneDefault(false);
          if (item.props.itemKey === CommandPanelTypes.People) togglePeople(props.selectedPane, props.setSelectedPane); props.setSelectedPaneDefault(false);
          if (item.props.itemKey === CommandPanelTypes.Add) toggleAdd(props.selectedPane, props.setSelectedPane); props.setSelectedPaneDefault(false);
          if (item.props.itemKey === CommandPanelTypes.Chat) toggleChat(props.selectedPane, props.setSelectedPane); props.setSelectedPaneDefault(false);
        }}
        styles={pivotItemStyles}
        initialSelectedKey={CommandPanelTypes.Chat}
        selectedKey={props.selectedPane}
      >
        <PivotItem
          itemKey={CommandPanelTypes.Settings}
          onRenderItemLink={() => (
            <SettingsIcon
              outline={props.selectedPane === CommandPanelTypes.Settings ? false : true}
              size="medium"
              className={pivotItemStyle(props) + ' ' + 'mob_seeting_icon'}
            />
          )}
        />
        <PivotItem
          itemKey={CommandPanelTypes.People}
          onRenderItemLink={() => (
            <UserFriendsIcon
              outline={props.selectedPane === CommandPanelTypes.People ? false : true}
              size="medium"
              className={pivotItemStyle(props) + ' ' + 'mob_seeting_icon'}
            />
          )}
        />
        <PivotItem
          itemKey={CommandPanelTypes.Add}
          onRenderItemLink={() => (
            <AddIcon
              outline={props.selectedPane === CommandPanelTypes.Add ? false : true}
              size="medium"
              className={pivotItemStyle(props) + ' ' + 'mob_seeting_icon'}
            />
          )}
        />
        <PivotItem
          itemKey={CommandPanelTypes.Chat}
          onRenderItemLink={() => (
            <ChatIcon
              outline={props.selectedPane === CommandPanelTypes.Chat ? false : true}
              size="medium"
              className={pivotItemStyle(props) + ' ' + 'mob_seeting_icon'}
            />
          )}
        />
        <PivotItem itemKey={CommandPanelTypes.None} />
      </Pivot>
      {
        isRecordingEnabled && <Stack style={{ marginLeft: '15px' }}>
          <CallRecording darkColor={props.darkColor} employeesCount={props.employeesCount} />
        </Stack>
      }
      {
        props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH && (
          <div className={separatorContainerStyle}>
            <Separator styles={separatorStyles} vertical={true} />
          </div>
        )
      }
      <MediaControls
        micActive={props.mic}
        onMicChange={handleMuteOnOff}
        cameraActive={props.localVideoStream !== undefined}
        onCameraChange={handleLocalVideoOnOff}
        screenShareActive={props.shareScreen}
        activeScreenShareStream={props.screenShareStreams[0] ?? undefined}
        onScreenShareChange={handleScreenSharingOnOff}
        onEndCallClick={() => {
          if (props.localVideo) handleLocalVideoOnOff();
          props.endCall();
        }}
        cameraPermission={props.cameraPermission}
        microphonePermission={props.microphonePermission}
        localVideoRendererIsBusy={props.localVideoRendererIsBusy}
        compressedMode={compressedMode}
        isLocalScreenShareSupportedInBrowser={props.isLocalScreenShareSupportedInBrowser}
        darkColor={props.darkColor}
        lightColor={props.lightColor}
        connected={props.connected}
      />
    </Stack >
  );
};
